import { FC, ReactElement, memo } from 'react';
import { useQueryClient } from 'react-query';

import { FallbackedLayout } from '@/common/layouts';

import { SearchConsoleUrlInspectionDomainsQueryKeys, useGetByIdSearchConsoleUrlInspectionDomainsQuery } from '@/modules/Domains';

import { SearchConsoleUrlInspectionDossierView } from './SearchConsoleUrlInspectionDossierView';

interface Props {
  siteId: string;
  domainId: string;
}

export const SearchConsoleUrlInspectionDossierContainer: FC<Props> = memo(({ domainId, siteId }) => {
  const queryClient = useQueryClient();

  const {
    data: urlInspectionDomainsData,
    error: urlInspectionDomainsError,
    isFetching: isUrlInspectionDomainsFetching,
    isError: isUrlInspectionDomainsError
  } = useGetByIdSearchConsoleUrlInspectionDomainsQuery(siteId, domainId)({
    enabled: !!siteId && !!domainId,
    onError: async () => {
      await queryClient.refetchQueries([SearchConsoleUrlInspectionDomainsQueryKeys.GetAll, siteId], { exact: false });
    }
  });

  return (
    <FallbackedLayout
      isLoading={ isUrlInspectionDomainsFetching }
      error={ urlInspectionDomainsError }
      isError={ isUrlInspectionDomainsError }
      data={ urlInspectionDomainsData }
    >
      { (): ReactElement => (
        <SearchConsoleUrlInspectionDossierView domainId={ domainId } siteId={ siteId }/>
      ) }
    </FallbackedLayout>
  );
});
